import React from 'react';
import {AddOutlined, DeleteForeverOutlined} from "@material-ui/icons";
import SidebarNoteItem from "../SidebarNoteItem";

const Sidebar = ({notes, addNote, deleteNote, activeNote, setActiveNote}) => {
    const sortedNotes = notes.sort(((a, b) => b.lastModified - a.lastModified))
    return (
        <div className="app-sidebar">
            <div className="app-sidebar-header">
                <h1>Todo App</h1>
                <button onClick={addNote}><AddOutlined/> </button>
            </div>
            <div className="app-sidebar-notes">
                {sortedNotes.map(note=>(
                    <SidebarNoteItem
                        key={note.id}
                        note={note}
                        activeNote={activeNote}
                        setActiveNote={setActiveNote}
                        deleteNote={deleteNote}
                    />
                ))}
            </div>
        </div>
    );
};

export default Sidebar;